export const errorIf = (condition: unknown, message: string) => {
  if (condition) {
    throw new Error(message);
  }

  return null;
};
